import { ShopType } from "@1games-ru/region-shared/dist/enums/shop/shop-type";
import { Colors } from "@/domains/shop/constants/colors";

export const shopsList = {
  [ShopType.Magnat]: {
    logo: "/svg/shop/logo/magnat.svg",
    color: Colors.Red,
    header: null,
  },
  [ShopType.Semerochka]: {
    logo: "/svg/shop/logo/semerochka.svg",
    color: Colors.Red,
    header: null,
  },
  [ShopType.Vkusmeal]: {
    logo: "/svg/shop/logo/vkusmill.svg",
    color: Colors.Green,
    header: null,
  },
  [ShopType.Dns]: {
    logo: "/svg/shop/logo/dns.svg",
    color: Colors.Yellow,
    header: null,
  },
  [ShopType.Zdravgorod]: {
    logo: "/svg/shop/logo/zdravgorod.svg",
    color: Colors.LightBlue,
    header: null,
  },
  [ShopType.Gaspro]: {
    logo: "/svg/shop/logo/gazpro.svg",
    color: Colors.LightBlue,
    header: "/svg/shop/header/gazpro.svg",
  },
  [ShopType.Russeti]: {
    logo: "/svg/shop/logo/russeti.svg",
    color: Colors.LightBlue,
    header: "/svg/shop/header/russeti.svg",
  },
  [ShopType.Luoil]: {
    logo: "/svg/shop/logo/luoil.svg",
    color: Colors.Red,
    header: "/svg/shop/header/luoil.svg",
  },
};
